module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/bookcase/wood.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/bookcase/wood.jpg
// module id = 180
// module chunks = 0